export default __webpack_public_path__ + "df98a161e71c40cdb2ebcf69f8604db0.svg";